import * as angular from 'angular';
//import { marked } from 'marked';
import * as marked from 'marked';
const hljs = require('highlight.js'); // Doing import hljs from 'highlight.js'; does not work...

import { ComponentDefinition } from '../../models';
import { ICurrentApplicationService, IConfigurationService, IConfigurationObject } from '../../services';
import { escapeAll, relativeUrl } from '../../relativeUrl';

/*
 * This controller is based on remark from angular-marked author:
 * https://github.com/Hypercubed/angular-marked/issues/70
 * Seems the way to have on-the-fly reconfiguration of renderer like we need to customize application
 */
class MarkdownRendererController implements angular.IComponentController {
    content: string;
    rendered: string;
    isLoading: boolean;
    hasSanitization: boolean;

    private _urlPromise: angular.IPromise<string>;

    static $inject = [
        '$sce',
        'currentApplicationService',
        'configurationService'
    ];

    constructor(
        private _$sce: angular.ISCEService,
        private _currentApplicationService: ICurrentApplicationService,
        private _configurationService: IConfigurationService
    ) {
        // be sure promise is there when onInit/onChange are called
        this._urlPromise = this._configurationService
            .getConfiguration()
            .then(config => config.apiUrl);
    }

    $onInit() {
        this.asyncRender();
    }

    $onChanges() {
        this.asyncRender();
    }

    // ensure configuration is loaded to render
    private asyncRender() {
        if (this.content) {
            this._urlPromise.then(url => this.render(url));
        }
    }

    // Render the content into html
    private render(apiUrl: string) {
        this.isLoading = true;
        const options = {
            gfm: true,
            tables: true,
            renderer: this.getRenderer(apiUrl),
            // langPrefix: 'hljs ',
            highlight: (code, language) => {
                try {
                    const validLanguage = hljs.getLanguage(language) ? language : 'plaintext';
                    return hljs.highlight(code, { language: validLanguage, ignoreIllegals: true }).value;
                }
                catch (e) {
                    console.error(e);
                }
            }
        };
        //const rawHtml = marked.parse(this.content, options);
        const rawHtml = marked(this.content, options);
        this.rendered = this.hasSanitization
            ? this._$sce.getTrustedHtml(rawHtml)
            : this._$sce.trustAsHtml(rawHtml);
        this.isLoading = false;
    }

    // Create renderer object for marked configuration
    private getRenderer(apiUrl: string): marked.Renderer {
        const customRenderer = new marked.Renderer();
        const appUrl = this._currentApplicationService.getApplicationConfiguration().guid;

        customRenderer.image = (href: string, title: string, text: string) => {
            const src = relativeUrl(href, apiUrl, appUrl);
            return `<img src="${src}" alt="${escapeAll(text)}" title="${title ? escapeAll(title) : src}" />`;
        };

        customRenderer.link = (href: string, title: string, text: string) => {
            const src = relativeUrl(href, apiUrl, appUrl);
            return `<a href='${src}' title='${title ? escapeAll(title) : src}' target='_blank'>${escapeAll(text)}</a>`;
        };


        return customRenderer;
    }
}

export const wtMarkdownRenderer: ComponentDefinition = {
    componentId: 'wtMarkdownRenderer',
    controller: MarkdownRendererController,
    template: require('./markdownRenderer.component.html'),
    controllerAs: 'vm',
    bindings: {
        content: '<',
        hasSanitization: '<?'
    }
};